import React from 'react'
// import LoaderButton from '../../components/LoaderButton'
// import FormViewer from '../../components/FormViewer'
import { translate } from "../../utils/useful";
// import Responsive from '../../components/Responsive';
// import TableViewer from '../../components/TableViewer';
// import SwitchInput from '../../components/inputs/SwitchInput';
// import StageActionButton from '../../components/partials/StageActionButton';
// import AddPermissionModal from '../../modals/AddPermissionModal';
// import SearchUsersModal from '../../modals/SearchUsersModal';
// import SearchGroupsModal from '../../modals/SearchGroupsModal';
// import SidebarView from '../../components/SidebarView';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
// import ActionButton from '../../components/partials/ActionButton';
// import CAHeader from '../../components/header/CAHeader';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
// import TextInput from '../../components/inputs/TextInput';
// import { nanoid } from 'nanoid';
// import SelectInput from '../../components/inputs/SelectInput';
// import Collapsible from 'react-collapsible';
// import CheckboxInput from '../../components/inputs/CheckboxInput';
// import FilterEditorInput from '../../components/inputs/FilterEditorInput';
// import RadiusSelectInput from '../../components/inputs/RadiusSelectInput';
// import HelpButton from '../../components/HelpButton';
import PermissionsView from '../../components/PermissionsView';
import HttpServices from '../../utils/Http.services';

class FramePermissions extends React.Component {
    state = {

        customAccess: {

        },

        frames: [],

        tabsView: {},

        admins: [],
        users: [],
        public: true,

        permissionsObject: {},


    }

    componentDidMount() {
        let me = this.props.user?.info
        let admins
        let users
        let publicStatus
        let owner


        if (this.props.setHeader) {
            this.props.setHeader({
                'toolbar': null,
                'showToolbar': false,
                isPortal: true, doNotshowNotification: true,
                showSettings: false,
                create: true,
                'title': this.props.description ?? 'Create Applet | Admins Access',
                topHeaderComponent: this.topHeaderComponent,
                backAction: () => this.props.lastStage()

            })
        }


        if (this.props.initData?.permissions && Array.isArray(this.props.initData?.permissions?.admins) && this.props.initData?.permissions?.admins?.length > 0) {
            // console.log('this.props.initData99', this.props.initData)
            admins = this.props.initData?.permissions?.admins
            // users = this.props.initData?.permissions?.users
            // publicStatus = this.props.initData?.permissions?.public
            // owner = this.props.initData?.permissions?.owner
        } else {

            if (this.props.variables?.appletId) {

                this.getAppletRoles()

            } else {
                // admins = [{ name: 'Owner', id: 'owner', mainAccess: true, hubs: [{ _id: me?._id, image: me?.image, fullname: me?.fullname, username: me?.username, type: 'user', owner: true }], permissions: '*' }]
                admins = [
                    { name: 'Full access', id: 'owner', locked: true, type: 'role', mainAccess: true, hubs: [{ _id: me?._id, image: me?.image, fullname: me?.fullname, username: me?.username, type: 'user', owner: true }], permissions: [] },
                    { name: 'General', id: 'general', type: 'role', hubs: [], permissions: [] }
                ]

                users = []
                publicStatus = true
                owner = me?._id
            }
        }



        let frames = []

        // console.log(this.props.initData)
        if (admins && Array.isArray(this.props.initData?.frames)) {
            frames = this.props.initData?.frames

            frames.forEach(frame => {
                if (frame.headers && !frame.fields) {
                    frame.fields = frame.headers

                }

                if (frame.title && !frame.name) {
                    frame.name = frame.title

                }

                if (frame.key && !frame.id) {
                    frame.id = frame.key

                }

                if (!this.props.initData?.permissions) {
                    admins.forEach(admin => {
                        let access = '*'
                        if (!admin.locked && frame.pageType == 'collection') {
                            access = { view: '*', create: '*', edit: '*', remove: '*' }
                        }
                        admin.permissions.push({ id: frame.id, type: 'frame', pageType: frame.pageType, access: access })
                    });
                }
            });
        }

        if (!admins || !admins[0]) {
            return
        }
        admins[0].permissions.push({ id: "applet", type: 'applet', access: '*' })

        this.setState({ admins, frames, users, owner, public: publicStatus }, () => {
        })




    }



    getAppletRoles = () => {

        // console.log("variables", this.props.variables)
        let body = { applet: this.props.variables?.appletId }

        this.setState({ isLoadingRoles: true })
        HttpServices.request('getAppletRoles', body, (fetchResult, fetchError) => {

            this.setState({ isLoadingRoles: false })

            if (fetchError) {
                return
            }
            let roles = fetchResult.info
            let admins = []
            let frames = this.props.frames


            roles.forEach(role => {
                let access = '*'
                let admin

                if (Array.isArray(frames) && role.locked == true) {
                    admin = role

                    if(!Array.isArray(admin.permissions)){
                        admin.permissions = []
                    }

                    console.log(frames)

                    frames.forEach(frame => {

                        admin.permissions.push({ id: frame.id, type: 'frame', pageType: frame.pageType, access: access })

                    });
                    admins.push(admin)

                }

            });

            this.setState({ frames, admins })
        })

    }



    onNextStage = () => {
        if (this.props.handleNextStage) {
            this.props.handleNextStage({ admins: this.state.admins, users: this.state.users, })
        }
        else {
            this.nextStage()
        }
    }


    topHeaderComponent = () => {
        return (
            <div className='flexc'>

                <ButtonAnimated
                    iconwidth='24px'
                    isLoading={this.state.isLoading}
                    // onClick={() => this.props.nextStage ? this.props.nextStage({ admins: this.state.admins, users: this.state.users, }) : this.nextStage()}
                    onClick={this.onNextStage}
                    title={this.props.title ?? translate("ca.Continue")}
                    icon='/assets/icons/angle-right-white2.svg'
                    textColor={'#222'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />

            </div>

        )
    }



    // setHeader = (key, value) => {
    //     if (this.header) {
    //         if (typeof key == 'object') {
    //             let object = {
    //                 showSettings: true,
    //                 showFrames: 'static'
    //             }
    //             if (this.props.defaultHeaderConfig) {
    //                 object = { ...this.props.defaultHeaderConfig }
    //             }
    //             for (const [okey, ovalue] of Object.entries(key)) {
    //                 object[okey] = ovalue
    //             }
    //             if (object.showSettings && this.props.showSettings) {
    //                 object.showSettings = this.props.showSettings
    //             }
    //             this.setState({ headerConfig: object }, () => {
    //                 this.header.forceUpdate()
    //             })
    //         }
    //         else {
    //             this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
    //                 this.header.forceUpdate()
    //             })
    //         }
    //     }
    // }


    // componentWillUnmount() {
    // }


    nextStage = () => {

        // TODO: Permissions

        let data = {
            admins: this.state.admins,
            // users: this.state.users,
            // publicPermissions: this.state.public,
        }

        let frames = this.state.frames
        // console.log(data)


        // let data = this.form.getForm()
        if (data) {
            // console.log('dseklnfjdnjk', this.props)
            this.props.setData({ permissions: data, frames }, () => {
                // this.props.nextStage()
                // console.log('permissionspermissions', this.props.initData)

                if (this.props.continue) {
                    this.props.continue(this.props.stageName)
                } else {

                    if (this.props.changeStage) {
                        if (Array.isArray(this.props.initData.features) && this.props.initData.features[0] == 'Inquiry') {
                            this.props.changeStage('info')
                        }
                        else {
                            this.props.changeStage('formType')
                        }
                    }
                }


            })
        }
    }


    changeValue = (key, value) => {
        this.setState({ [key]: value })
    }



    setAdmins = (admins, cb) => {
        this.setState({ admins }, () => {
            if (cb) {
                cb()
            }
        })
    }


    render() {

        let variables = this.props.variables
        if (!variables) {
            variables = {}
        }
        
        // console.log("variables",variables)

        let user = this.props.initData?.hub ?? this.props.user?.info?._id
        variables.user = user
        variables.targetId = user


        return (
            <div className=' w-100 h-100 window-content-radius' style={{}}>
                <div className=" w-100 h-100 scroll-no-scrollbar pb-5 position-relative  flex-column window-content-radius" style={{}}>

                    <div className=' w-100 '>
                        <div className='w-100' >
                            <PermissionsView maxWidth={650} frames={this.state.frames} width={this.props.width} admins={this.state.admins} setAdmins={this.setAdmins} applet={false} defaultOpen={false} type={"frame"} variables={this.props.variables} />
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FramePermissions);
